<div class="home">
  <div class="header">
    <h1>寻迹后台管理</h1>
    <button @click="handleLogout" class="logout-btn">退出登录</button>
  </div>
  <div class="main">
    <div class="nav-menu">
      <div 
        class="menu-item" 
        :class="{ active: activeMenu === 'dashboard' }"
        @click="switchMenu('dashboard')"
      >
        统计
      </div>
      <div 
        class="menu-item" 
        :class="{ active: activeMenu === 'manage' }"
        @click="switchMenu('manage')"
      >
        管理
      </div>
      <div 
        class="menu-item" 
        :class="{ active: activeMenu === 'users' }"
        @click="switchMenu('users')"
      >
        用户
      </div>
      <div
        class="menu-item"
        :class="{ active: activeMenu === 'createManagement' }"
        @click="switchMenu('createManagement')"
      >
        创建管理
      </div>
      <div
        class="menu-item"
        :class="{ active: activeMenu === 'background' }"
        @click="switchMenu('background')"
      >
        背景模板
      </div>
      <div
        class="menu-item"
        :class="{ active: activeMenu === 'tombstone' }"
        @click="switchMenu('tombstone')"
      >
        墓碑模板
      </div>
      <div
        class="menu-item"
        :class="{ active: activeMenu === 'couplet' }"
        @click="switchMenu('couplet')"
      >
        挽联管理
      </div>
      <div
        class="menu-item"
        :class="{ active: activeMenu === 'halls' }"
        @click="switchMenu('halls')"
      >
        祠堂管理
      </div>
      <div
        class="menu-item"
        :class="{ active: activeMenu === 'recommendHalls' }"
        @click="switchMenu('recommendHalls')"
      >
        推荐祠堂
      </div>
      <div
        class="menu-item"
        :class="{ active: activeMenu === 'recommendPersons' }"
        @click="switchMenu('recommendPersons')"
      >
        推荐纪念人
      </div>
      <div
        class="menu-item"
        :class="{ active: activeMenu === 'products' }"
        @click="switchMenu('products')"
      >
        商品管理
      </div>
      <div
        class="menu-item"
        :class="{ active: activeMenu === 'heritage' }"
        @click="switchMenu('heritage')"
      >
        文章管理
      </div>
      <div
        class="menu-item"
        :class="{ active: activeMenu === 'heritageCategory' }"
        @click="switchMenu('heritageCategory')"
      >
        分类管理
      </div>
      <div
        class="menu-item"
        :class="{ active: activeMenu === 'commentTemplate' }"
        @click="switchMenu('commentTemplate')"
      >
        评论模板
      </div>
      <div
        class="menu-item"
        :class="{ active: activeMenu === 'legal' }"
        @click="switchMenu('legal')"
      >
        协议管理
      </div>
      <div
        class="menu-item"
        :class="{ active: activeMenu === 'platformContact' }"
        @click="switchMenu('platformContact')"
      >
        平台联系人
      </div>
    </div>
    <div class="content">
      <component :is="currentView"></component>
    </div>
  </div>
</div> 
